import React from "react"
import styles from "./chatBots.module.css"
import FormGroup from "../../../components/Form/FormGroup"

const sections = [
    // {
    //     title: "Decisões e Fluxo",
    //     nodes: [
    //         { data: { label: "Período sem resposta" }, type: "noResponsePeriod", className: styles.noResponsePeriod },
    //         { data: { label: "Aguardar Tempo" }, type: "waitTime", className: styles.waitTime },
    //     ],
    // },
    {
        title: "Inteligência Artificial",
        nodes: [
            { data: { label: "Instruções IA" }, type: "aiInstructions", className: styles.aiInstructions },
            { data: { label: "Resposta Inteligente" }, type: "aiResponse", className: styles.aiResponse },
            { data: { label: "Condicional" }, type: "aiConditional", className: styles.aiConditional },
        ],
    },
    // {
    //     title: "Ações",
    //     nodes: [
    //         // { data: { label: "Realizar Consulta" }, type: "makeConsultation", className: styles.makeConsultation },
    //         // { data: { label: "Buscar Informações Externas" }, type: "fetchExternalData", className: styles.fetchExternalData },
    //         { data: { label: "Registrar Evento no CRM" }, type: "logCRM", className: styles.logCRM },
    //         // { data: { label: "Salvar em Variável" }, type: "saveToVariable", className: styles.saveToVariable },
    //     ],
    // },
    // {
    //     title: "Mensagens",
    //     nodes: [
    //         { data: { label: "Enviar Mensagem" }, type: "sendMessage", className: styles.sendMessage },
    //         { data: { label: "Mensagem Interna" }, type: "internalMessage", className: styles.internalMessage },
    //     ],
    // },
    {
        title: "Suporte e Atendimento",
        nodes: [
            { data: { label: "Encerrar o Atendimento" }, type: "closeConversation", className: styles.closeConversation },
            { data: { label: "Transferir Atendimento" }, type: "transferService", className: styles.transferService },
        ],
    },
]

const Aside = () => {
    const dragStart = (event, node) => {
        event.dataTransfer.setData("application/reactflow", JSON.stringify(node));
    }

    return (
        <aside className={styles.sidebar}>
            {sections.map((section, index) => (
                <FormGroup labelText={section.title} key={index}>
                    <div className={styles.section}>
                        {section.nodes.map((node, index) => (
                            <div className={`${styles.node} ${node.className}`} draggable onDragStart={(event) => dragStart(event, node)} key={index}>
                                {node.data.label}
                            </div>
                        ))}
                    </div>
                </FormGroup>
            ))}
        </aside>
    )
}

export default Aside
